<template>
  <div
    v-for="({ count, rating, percentage }, index) in countPerRating"
    :key="index"
    class="rating-block"
    :data-testid="starRatingSnapshotBlock"
  >
    <button
      class="rating-value"
      :class="{'link-body': count}"
      :data-testid="starRatingSnapshotBlockValue"
      :data-testvalue="rating"
      @click="onRatingClick(rating, count)"
    >
      {{ rating }} {{ isMcom ? 'S' : 's' }}tar{{ rating > 1 ? 's' : '' }}
    </button>
    <div
      class="text-center rating-percentage"
      :data-testid="starRatingSnapshotBlockVisualizer"
    >
      <StarCountVisualizer :value="percentage" />
    </div>
    <div
      class="text-right body rating-count"
      :data-testid="starRatingSnapshotBlockCount"
    >
      {{ count }}
    </div>
  </div>
</template>

<script setup>
import { useBrand } from '@composables/useBrand';
import { useReviews } from '@composables/reviews/useReviews';
import { useProduct } from '@modules/product';
import { trackEvent } from '@utils/bvPixel';
import StarCountVisualizer from './StarCountVisualizer';
import {
  starRatingSnapshotBlock,
  starRatingSnapshotBlockCount,
  starRatingSnapshotBlockValue, starRatingSnapshotBlockVisualizer,
} from '../../../constants/testIds';

defineProps({
  countPerRating: {
    /** @type import('vue').PropType<CountPerRating[]> */
    type: Array,
    required: true,
  },
});

const { productId } = useProduct();

const { isMcom } = useBrand();
const { handleFilterByChange, expandReviews } = useReviews();
/**
* @param {number} rating
* @param {number} count
*/
function onRatingClick(rating, count) {
  if (!count) return;
  expandReviews();
  handleFilterByChange(String(rating));
  // BV track for stats - these run when user clicks on a star rating from top histogram
  trackEvent('filter', productId, 'star_snapshot', String(rating));
}
</script>

<style scoped lang="scss">
.rating-block {
  display: flex;
  height: rem-calc(20);
}

.rating-value, .rating-count {
  width: rem-calc(48);
}

.rating-percentage {
  flex-grow: 1;
  padding: rem-calc(4) rem-calc(8);
}
</style>
